// extracted by mini-css-extract-plugin
module.exports = {"sso":"michelin_sso__3JlBk","container":"michelin_container__2Ecpl","image-container":"michelin_image-container__2zYWc"};